import { KYMW0900Model } from '../kymw0900.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { CoopPlanNumRequestModel } from '../vo/kymw0900-coop-plan-num-request.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 会員生協計画数取得サービス
 *
 * @export GetCoopPlanNumService
 * @class GetCoopPlanNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCoopPlanNumService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetCoopPlanNumService
   */
  private model: KYMW0900Model;


  /**
   * 処理に使用するvo
   *
   * @private
   * @type {CoopPlanNumRequestModel}
   * @memberof GetCoopPlanNumService
   */
  private vo: CoopPlanNumRequestModel = null;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetCoopPlanNumService
   */
  private successFunc: Function;


  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCoopPlanNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          parameter: {
            CalculationDiv: this.vo.calculationDiv,
            MediumType: this.vo.mediumType,
            ClassCode: this.vo.classCode,
            LargeClassCode: this.vo.largeClassCode,
            MiddleClassCode: this.vo.middleClassCode,
            PlanNumTotal: this.vo.planNumTotal,
            PlanPI: this.vo.planPI
          },
          combination: this.vo.coopInfoList.map(coopInfo => {
            // 会員生協情報セット追加
            return {
              condition: {
                CoopCode: PlessViewUtilsSub.nullToBlank(coopInfo.CoopCode),
                DelivCatalogID: PlessViewUtilsSub.isEmpty(coopInfo.DelivCatalogID) ? '' : PlessViewUtilsSub.nullToBlank(coopInfo.DelivCatalogID),
                ItemCode: PlessViewUtilsSub.isEmpty(coopInfo.ItemCode) ? '' : PlessViewUtilsSub.nullToBlank(coopInfo.ItemCode),
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetCoopPlanNumService
   */
  execute(model: any, vo: CoopPlanNumRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCoopPlanNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCoopPlanNumService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.updatePlanNumList(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
